/* eslint-disable */
export default {
  header: '오류 추적 끄기',
  content:
    '오류 추적 모드를 끄면 현재 오류 로그가 삭제됩니다. 계속하시겠습니까?',
  confirm: '끄기',
  cancel: '취소',
} as const;

// @key: @#@"header"@#@ @source: @#@"Turn off error tracking"@#@
// @key: @#@"content"@#@ @source: @#@"Turning off error tracking mode will delete any current error logs. Do you wish to continue?"@#@
// @key: @#@"confirm"@#@ @source: @#@"Turn off"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
